var _desc, _defs, _rect, _rect2, _path, _rect3, _path2, _g, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNostratvLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1024,
    height: 1024,
    viewBox: "0 0 1024 1024",
    fill: "none",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "NOStraTV") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "description"
  }, "A red Iberian fox with dark-tipped ears, a slender muzzle and white cheeks inside an electric-blue widescreen television. A small semi-transparent white play triangle sits at the lower right.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "background",
    x1: 128,
    y1: 0,
    x2: 896,
    y2: 1024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#641E2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#350E1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#190810"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fox",
    x1: 342,
    y1: 326,
    x2: 582,
    y2: 643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6857"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#F23D40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BD183A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "blue",
    x1: 160,
    y1: 280,
    x2: 860,
    y2: 740,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#70BFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3787FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2456D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "screen",
    x1: 188,
    y1: 290,
    x2: 824,
    y2: 682,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10264A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1429"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1024,
    height: 1024,
    rx: 224,
    fill: "url(#background)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 1022,
    height: 1022,
    rx: 223,
    stroke: "#FF807F",
    strokeOpacity: 0.15,
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 710V771M421 782H603",
    stroke: "url(#blue)",
    strokeWidth: 24,
    strokeLinecap: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 256,
    width: 752,
    height: 464,
    rx: 64,
    fill: "url(#screen)",
    stroke: "url(#blue)",
    strokeWidth: 24
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M191 310H263",
    stroke: "#B9DFFF",
    strokeOpacity: 0.45,
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fox-mark",
    transform: "translate(40 6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M310 313Q307 300 319 307L427 379Q472 367 517 379L625 307Q637 300 634 313L610 468L641 493L490 650Q472 668 454 650L303 493L334 468Z",
    fill: "url(#fox)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310 313Q307 300 319 307L380 348L323 386Z",
    fill: "#09162C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625 307Q637 300 634 313L621 386L564 348Z",
    fill: "#09162C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337 354L402 398L350 437Z",
    fill: "#982641"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607 354L542 398L594 437Z",
    fill: "#982641"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303 493L366 487Q412 505 451 560L472 610L454 650Z",
    fill: "#FFF2EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641 493L578 487Q532 505 493 560L472 610L490 650Z",
    fill: "#DCEAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365 464L426 486Q399 512 377 487Z",
    fill: "#0A172D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579 464L518 486Q545 512 567 487Z",
    fill: "#0A172D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390 480L408 486",
    stroke: "#9BCBFF",
    strokeWidth: 5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554 480L536 486",
    stroke: "#9BCBFF",
    strokeWidth: 5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450 597Q472 586 494 597L478 617Q472 624 466 617Z",
    fill: "#09162C"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "play-overlay",
    transform: "translate(740 616) scale(0.6)",
    d: "M-64-98Q-64-110-54-104L118-10Q134 0 118 10L-54 104Q-64 110-64 98Z",
    fill: "#FFFFFF",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNostratvLogo);
export default __webpack_public_path__ + "static/media/nostratv-logo.d6e06b49155ca26878c0c5806d98d415.svg";
export { ForwardRef as ReactComponent };